<div [ngStyle]="{'left.px': x, 'top.px': y}" [ngClass]="{'d-none': !isShow,  'dropdown-menu-fav-dark': !isDarkTheme ,  'dropdown-menu-fav' : isDarkTheme }">
  <ul>
  <li class="add-favorite" [ngClass]="{'d-none': !isShow,  'dropdown-item-fav-dark': !isDarkTheme ,  'dropdown-item-fav' : isDarkTheme }">
    <i class="fas fa-plus" (click)="toggleAddFavorite($event)"></i>
    <span *ngIf="!showAddFavorite" (click)="toggleAddFavorite($event)">{{"AddNewFavoriteList" | translate}}</span>

    <input *ngIf="showAddFavorite" 
           type="text" 
           [(ngModel)]="newFavoriteName" 
           [placeholder]="'NewFavoriteList' | translate" 
           class="form-control" 
           (click)="preventCloseOnInternalClick($event)" />

    <button *ngIf="showAddFavorite" 
            (click)="createFavorite(item.symbol)" 
            class="btn btn-primary btn-create"
            (click)="preventCloseOnInternalClick($event)">
            {{"Create" | translate}}
    </button>

    <div *ngIf="errorMessage" class="alert alert-danger mt-2">
      {{ errorMessage }}
    </div>
  </li>

  <li *ngIf="marketWatches.length === 0">
    <a class="dropdown-item-fav">{{"NoFavoriteLists" | translate}}</a>
  </li>
  <li *ngFor="let watch of marketWatches"
  class="dropdown-item-fav"
  (click)="selectMarketWatch(watch, item.symbol)"
  [ngClass]="{'dropdown-item-fav-dark': !isDarkTheme ,  'dropdown-item-fav' : isDarkTheme }">

<!-- Default list flag -->
<i class="fa-solid fa-flag" *ngIf="watch.IsDefault"></i>

<!-- Star if symbol exists -->
<i class="fas fa-star text-warning" *ngIf="isSymbolInWatch(item?.symbol, watch)"></i>

{{ watch.MarketWatchName }}

<!-- delete -->
<i class="fas fa-trash" style="color: red;" (click)="deleteMarketWatch(watch?.MarketWatchID)"></i>
</li>

</ul>
</div>
